<template>
  <div>
    <ca-heading text="Exportação de Arquivo para Bancos" />
    <ca-page>
      <ca-row vertical-offset="2">
        <ca-col
          size="8"
          offset="2"
          align="left">
          <ca-form
            :on-submit="onSubmit"
            :on-submit-success="onSubmitSuccess"
            :on-submit-error="onSubmitError"
            :error-message="errorMessage">
            <ca-row>
              <ca-col size="6">
                <ca-field label="Mês">
                  <ca-monthpicker v-model="selectedDate"></ca-monthpicker>
                </ca-field>
              </ca-col>
              <ca-col size="6">
                <worker-select
                  v-model="bankFile.funcionario"
                  show-all
                  required>
                </worker-select>
              </ca-col>
            </ca-row>

            <ca-row>
              <ca-col size="6">
                <stocking-select
                  v-model="bankFile.lotacao"
                  show-all
                  required>
                </stocking-select>
              </ca-col>

              <ca-col size="6">
                <job-description-select
                  v-model="bankFile.funcao"
                  show-all>
                </job-description-select>
              </ca-col>

              <ca-col size="6">
                <ca-field label="Origem do Pagamento">
                  <ca-select v-model="bankFile.origemPagamento.name">
                    <ca-option
                      v-for="paymentOrigin in misc.paymentOrigins"
                      :key="paymentOrigin.name"
                      :value="paymentOrigin.name">
                      {{ paymentOrigin.description }}
                    </ca-option>
                  </ca-select>
                </ca-field>
              </ca-col>
              <ca-col size="6">
                <ca-field label="Data do Pagamento">
                  <ca-date-input
                    v-model="bankFile.dtPagamento"
                    required>
                  </ca-date-input>
                </ca-field>
              </ca-col>
              <ca-col size="6">
                <ca-field label="Sequência do Arquivo">
                  <ca-input
                    v-model="bankFile.seqArquivo"
                    maxlength="20"
                    required>
                  </ca-input>
                </ca-field>
              </ca-col>
              <ca-col size="6">
                <ca-field label="Adicionar Bolsa Estagiários">
                  <ca-row>
                    <ca-col size="6">
                      <ca-checkbox
                        v-model="bankFile.indAdcEstagiario"
                        label="Sim">
                      </ca-checkbox>
                    </ca-col>
                  </ca-row>
                </ca-field>
              </ca-col>
              <ca-col class="ca-u-text-center">
                OBS: Somente funcionários com Ficha de Registro
                cadastrada serão incluídos no arquivo.
              </ca-col>
            </ca-row>
            <ca-footer>
              <ca-row vertical-offset="2">
                <ca-col offset="10" size="2">
                  <ca-submit-button>
                    Gerar
                  </ca-submit-button>
                </ca-col>
              </ca-row>
            </ca-footer>
          </ca-form>
        </ca-col>
      </ca-row>
    </ca-page>
  </div>
</template>

<script>
import moment from 'moment';
import { getFormattedPeriod } from 'packages/common/utils/format';
import { getBoxInformationErrorMessage } from 'packages/common/utils';
import { downloadFile } from 'packages/common/utils/file';
import { generateBankFile } from './bankFileService';


export default {
  name: 'BankFilePage',
  data() {
    return {
      bankFile: { periodo: moment().format('DD/MM/YYYY'), origemPagamento: {} },
      errorMessage: null,
      selectedDate: moment().format('DD/MM/YYYY'),
    };
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.bankFile.funcionario = null;
      this.bankFile.lotacao = null;
      this.bankFile.origemPagamento.name = 'F';

      this.$store.dispatch('misc/getPaymentOrigins');
    },
    onSuccess() {
      this.$toaster.success({
        title: 'Sucesso',
        content: 'Exportação realizada com sucesso!',
      });
    },
    onSubmit() {
      this.bankFile.periodo = getFormattedPeriod(this.selectedDate);
      return generateBankFile(this.bankFile);
    },
    onSubmitSuccess(response) {
      downloadFile(response.file, response.fileName);
      this.$toaster.success('Arquivo gerado com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
  },
};
</script>
